import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBps, FctValue } from '../../../../Fct/generics';
import { FaUserCircle } from 'react-icons/fa';
import { POOL_ADDRESSES } from '../constants';
export var GetUserAccountData = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getUserAccountData',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    user: new FctAddress({ isPreview: true, icon: FaUserCircle }),
                },
            },
            output: {
                totalCollateralBase: new FctValue({ innerIndex: 0, isPreview: true }),
                totalDebtBase: new FctValue({ innerIndex: 1, isPreview: true }),
                availableBorrowsBase: new FctValue({ innerIndex: 2, isPreview: true }),
                currentLiquidationThreshold: new FctBps({ innerIndex: 3, isPreview: true }),
                ltv: new FctBps({ innerIndex: 4, isPreview: true }),
                healthFactor: new FctValue({ innerIndex: 5, isPreview: true }),
            },
        });
    },
});
